<div class="overlay">
  <mat-spinner diameter="50"></mat-spinner>
</div>
